module.exports = __webpack_public_path__ + "img/map-button.b2067a88.svg";